import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { projects } from "../data/mock";
import { openContactModal } from "../lib/contactBus";

const filters = ["All", "Full Renovation", "Kitchen + Living", "Gut Renovation", "New Construction", "Full Build-out", "Addition + Reno"];

export default function Projects() {
  const [filter, setFilter] = useState("All");
  const list = filter === "All" ? projects : projects.filter((p) => p.type === filter);

  return (
    <>
      <section className="max-w-[1480px] mx-auto px-6 lg:px-10 pt-16 pb-10">
        <p className="section-tag mb-4">// SELECTED WORK</p>
        <h1 className="font-display text-[72px] sm:text-[112px] lg:text-[160px] uppercase leading-[0.88]">
          Builds<br /><span className="text-[var(--terracotta)]">on record.</span>
        </h1>
        <p className="mt-8 text-[15px] leading-7 text-[var(--slate-700)] max-w-2xl">
          A rotating selection of recent Edge Developer projects. Every photo is a client we still keep in touch with.
        </p>
      </section>

      <section className="max-w-[1480px] mx-auto px-6 lg:px-10 pb-6">
        <div className="flex gap-2 flex-wrap border-y border-[var(--slate-300)] py-4">
          {filters.map((f) => (
            <button key={f} onClick={() => setFilter(f)}
              className={`px-4 py-2 font-mono-sans text-[11px] font-semibold tracking-widest border transition-colors ${
                filter === f
                  ? "bg-[var(--slate-900)] border-[var(--slate-900)] text-[var(--off-white)]"
                  : "bg-transparent border-[var(--slate-300)] text-[var(--slate-900)] hover:border-[var(--slate-900)]"
              }`}
            >{f.toUpperCase()}</button>
          ))}
        </div>
      </section>

      <section className="max-w-[1480px] mx-auto px-6 lg:px-10 py-12">
        {list.length === 0 ? (
          <p className="text-center text-[14px] text-[var(--slate-500)] py-20">No projects match this filter yet.</p>
        ) : (
          <div className="grid grid-cols-12 gap-3 lg:gap-4">
            {list.map((p, i) => (
              <article key={p.slug} className={`bento-card relative overflow-hidden group ${i % 3 === 0 ? "col-span-12 lg:col-span-7" : "col-span-12 lg:col-span-5"} min-h-[420px]`}>
                <img src={p.image} alt={p.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--slate-950)]/90 via-[var(--slate-950)]/20 to-transparent" />
                <div className="absolute inset-0 p-6 flex flex-col justify-between text-[var(--off-white)]">
                  <div className="flex justify-between items-start">
                    <span className="font-mono-sans text-[10px] bg-[var(--slate-900)]/80 backdrop-blur px-2 py-1">{p.year}</span>
                    <span className="font-mono-sans text-[10px] bg-[var(--terracotta)] px-2 py-1">{p.type.toUpperCase()}</span>
                  </div>
                  <div>
                    <p className="font-mono-sans text-[10px] text-[var(--terracotta-light)] mb-1">// {p.location.toUpperCase()} — {p.sqft} SQ FT</p>
                    <h3 className="font-display text-[40px] lg:text-[56px] uppercase leading-[0.95]">{p.title}</h3>
                    <p className="text-[13px] text-[var(--slate-300)] mt-1">{p.subtitle}</p>
                    <span className="mt-3 inline-flex items-center gap-2 font-mono-sans text-[11px] tracking-widest text-[var(--off-white)] group-hover:text-[var(--terracotta-light)] transition-colors">
                      VIEW CASE <ArrowUpRight size={14} />
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      <section className="bg-[var(--bg-secondary)] py-16 mt-12">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-10 grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 lg:col-span-8">
            <p className="section-tag mb-3">// NEXT BUILD</p>
            <h2 className="font-display text-[40px] sm:text-[64px] uppercase leading-[0.95]">Could be<br /><span className="text-[var(--terracotta)]">yours.</span></h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:text-right">
            <button onClick={openContactModal} className="btn-terracotta">Start A Project <ArrowRight size={15} /></button>
            <div className="mt-3">
              <Link to="/services" className="link-tick font-mono-sans text-[11px] font-semibold tracking-widest text-[var(--slate-900)]">
                BROWSE SERVICES <ArrowUpRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
